import React from 'react';
const rows = [{
  category: 'Planificación',
  before: 'Noches de domingo buscando ejercicios que no tienen conexión.',
  after: '−90% tiempo. Sesiones listas en tu tablet en solo 2 clics.'
}, {
  category: 'Seguridad',
  before: 'Dudas al explicar sistemas defensivos o transiciones.',
  after: 'Confianza total. Diagramas HD claros y efectivos.'
}, {
  category: 'Variedad',
  before: 'Entrenamientos mecánicos que aburren a los jugadores.',
  after: '+100% originalidad. Drills que desafían y motivan.'
}, {
  category: 'Energía',
  before: 'Llegas a la cancha mentalmente cansado de organizar todo.',
  after: 'Cero estrés. Llegas con la cabeza lista para dirigir.'
}];
export function ContrastSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-63">
      <div className="max-w-4xl mx-auto" data-id="element-64">
        {/* Intro headline */}
        <div className="text-center mb-10" data-id="element-65">
          <span className="inline-block text-primary font-bold text-sm tracking-widest uppercase mb-3" data-id="element-66">
            ⚡ La transformación
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-67">
            De un entrenador agotado a un{' '}
            <span className="text-primary" data-id="element-68">estratega inspirado.</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-2xl mx-auto" data-id="element-69">
            Esto es lo que cambia desde la primera semana con Handball Listo en
            tus manos.
          </p>
        </div>

        {/* Time cost callout */}
        <div className="bg-badge-red/10 border border-badge-red/20 rounded-2xl p-6 sm:p-8 mb-12 text-center" data-id="element-70">
          <div className="text-badge-red font-black text-3xl sm:text-5xl tracking-tight mb-2 drop-shadow-[0_0_15px_rgba(239,68,68,0.3)]" data-id="element-71">
            150+ horas / año
          </div>
          <p className="text-text-main text-sm sm:text-lg font-medium leading-relaxed" data-id="element-72">
            <span className="font-bold" data-id="element-73">El costo real:</span> Planificar
            manualmente te quita de{' '}
            <span className="text-badge-red font-bold" data-id="element-74">
              3 a 5 horas por semana
            </span>
            . Es el equivalente a{' '}
            <span className="text-badge-red font-bold" data-id="element-75">
              un mes entero de trabajo al año
            </span>{' '}
            quemado en cuadernos, dibujos y dudas tácticas.
          </p>
        </div>

        <div className="bg-bg-alt rounded-2xl shadow-2xl border border-border-light overflow-hidden" data-id="element-76">
          {/* Header */}
          <div className="grid grid-cols-1 md:grid-cols-2 border-b border-border-light bg-white/5" data-id="element-77">
            <div className="px-6 py-5 font-bold text-badge-red text-center md:text-left border-b md:border-b-0 md:border-r border-border-light tracking-wider text-sm" data-id="element-78">
              SIN EL KIT (Improvisación)
            </div>
            <div className="px-6 py-5 font-black text-primary text-center md:text-left tracking-wider text-sm drop-shadow-[0_0_8px_rgba(59,130,246,0.3)]" data-id="element-79">
              CON EL MEGAPACK (Handball Listo)
            </div>
          </div>

          {/* Rows */}
          <div className="divide-y divide-border-light" data-id="element-80">
            {rows.map((row, i) => <div key={i} className="group hover:bg-white/[0.02] transition-colors" data-id="element-81">
                {/* Category label */}
                <div className="px-6 pt-4 text-text-sec text-xs font-bold tracking-widest uppercase" data-id="element-82">
                  {row.category}
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-83">
                  <div className="px-6 py-5 flex items-start gap-4 border-b md:border-b-0 md:border-r border-border-light bg-black/20" data-id="element-84">
                    <div className="w-6 h-6 rounded-full bg-badge-red/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-badge-red/30" data-id="element-85">
                      <span className="text-badge-red font-bold text-sm" data-id="element-86">
                        ✕
                      </span>
                    </div>
                    <p className="text-text-sec font-medium" data-id="element-87">{row.before}</p>
                  </div>
                  <div className="px-6 py-5 flex items-start gap-4 bg-primary/5 relative overflow-hidden" data-id="element-88">
                    <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-89"></div>
                    <div className="w-6 h-6 rounded-full bg-check-green/20 flex items-center justify-center flex-shrink-0 mt-0.5 border border-check-green/30 relative z-10" data-id="element-90">
                      <span className="text-check-green font-bold text-sm" data-id="element-91">
                        ✓
                      </span>
                    </div>
                    <p className="text-text-main font-bold relative z-10" data-id="element-92">
                      {row.after}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}